<template>
  <div class="tw:mb-6 tw:border-b tw:border-gray-300 tw:pb-6">
    <div class="tw:flex tw:flex-col tw:md:flex-row tw:items-start tw:justify-between tw:w-full">
      <div class="tw:w-full tw:md:w-1/2 tw:flex tw:flex-col tw:items-start tw:mb-6 tw:md:mb-0 tw:pr-8">
        <h3 class="tw:font-bold tw:text-xl tw:mb-4">{{ $t('tbs_home_hotel_offers_subtext') }}</h3>
        <ul class="tw:mb-6 tw:flex tw:flex-col tw:grow">
          <li class="tw:gap-x-1 tw:flex tw:items-center" v-for="(item, index) in benefits" :key="index">
            <CheckPointIcon />
            <span class="tw:md:text-nowrap">{{ $t(item) }}</span>
          </li>
        </ul>
        <MainButton @click="createNewOffer" size="medium">{{ $t('hotel_offers_cta_new') }}</MainButton>
      </div>
      <div class="tw:md:flex tw:md:w-1/2 tw:hidden">
        <img :src="hotelOffersBannerImage" alt="Hotel Offers" class="tw:md:max-h-[190px]" />
      </div>
    </div>
  </div>
</template>
<script setup>
import CheckPointIcon from '@/components/icons/CheckPointIcon.svg?component'
import MainButton from '@/components/base/buttons/MainButton.vue'

import appAnalytics from '@/utils/tracking'

import { useHotelOffers } from '@/components/hotelOffers/useHotelOffers.js'
import { selectedAccommodationId } from '@/layouts/queries'

const hotelOffersBannerImage = new URL('/src/assets/img/hotel-offers/hotel-offers-banner.png', import.meta.url)
const benefits = ['tbs_home_hotel_offers_point_1', 'tbs_home_hotel_offers_point_2', 'tbs_home_hotel_offers_point_3']

const { openCreateOfferFromHomepage } = useHotelOffers()

const createNewOffer = () => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_PLUS_CREATE_NEW_OFFER, {
    accommodationId: selectedAccommodationId.value,
  })
  openCreateOfferFromHomepage()
}
</script>
